var params = require('./params.json')
params.genesisState = require('./genesisState.json')
params.bootstrapNodes = require('./bootstrapNodes.json')
module.exports = params
